import axios from 'axios';
import { API, Auth } from "aws-amplify";
import config from './config'

const instance = axios.create({
    baseURL: config.ApiGateway
});

export default instance;